import React, { type ReactNode } from 'react';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import {
	type CategoryGuid,
	categoryGuidToString,
} from '@atlassian/jira-servicedesk-knowledge-services/src/types';

type CategoryBreadcrumbProps = {
	children: ReactNode;
	id: CategoryGuid;
	name: string | undefined;
	baseUrl: string;
	projectKey: string;
};

export default function CategoryBreadcrumbItem({
	id,
	name,
	children,
	baseUrl,
	projectKey,
}: CategoryBreadcrumbProps) {
	if (name === undefined) {
		return null;
	}

	return (
		<Breadcrumb
			breadcrumb={{
				href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge/categories/${categoryGuidToString(
					id,
				)}`,
				text: name,
				type: 'jsd-category-link',
			}}
		>
			{children}
		</Breadcrumb>
	);
}
